import { BreadcrumbItem } from './../sub-header/sub-header.component';

export class HeaderTitle {
    constructor(public breadcrumbs: BreadcrumbItem[]) {
    }
}
